import React from 'react'
import { Row } from 'react-flexbox-grid';
import styles from '../styles/tickers.module.scss'
import { FaPlus, FaRegTrashAlt, FaBan, FaAngleDown, FaAngleUp } from "react-icons/fa";
import { X } from 'react-feather';
import Switch from "react-switch";
import Autocomplete from "react-autocomplete-select";
import Tooltip from "../../../components/Tooltip";
import cities from '../../settings/citiesUSA'

const uuidv4 = require('uuid/v4')

const renderList = (props) => {
    if (props.ticker.length === 0) {
        return (
            <div className={styles.__no_tickers}>
                <div><FaBan size={20} color={'#D9D9D9'} /></div>
                <div className={styles.__message_no_tickers}>No tickers yet</div>
            </div>
        )
    }
    else {
        let listTickers = props.ticker.map((item, index) => {
            return (
                <>
                {props.title === 'Weather Forecast' && index === 1 &&
                    <div className={styles.__weather_defaul}>Other Locations</div>
                }
                <div className={styles.__ticker_container} >
                    <div className={styles.__angle_content}>
                    <FaAngleUp size={15} color={'#68D2DF'} style={{ cursor: props.editing ? '' : 'pointer'}}
                        onClick={() => {
                            if(index > 0 && !props.editing)
                            props.changePosition(props.ticker, index, index-1, props.label)}}
                    />
                    <FaAngleDown size={15} color={'#68D2DF'} style={{ cursor: props.editing ? '' : 'pointer'}}
                        onClick={() => {
                            if(index < props.ticker.length -1 && !props.editing)
                            props.changePosition(props.ticker, index, index+1, props.label)}
                        }
                    />
                    </div>
                    <div className={styles.__switch}>
                        <Switch
                            checked={item.active}
                            disabled={props.editing}
                            onChange={() => props.handleSwitch(index, props.label)}
                            onColor="#9CFFFF"
                            onHandleColor="#68D2DF"
                            handleDiameter={20}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            height={16}
                            width={40}
                            className="react-switch"
                            id="material-switch"
                        />
                    </div>
                    {!item.edit &&
                        <>
                            <div
                                className={styles.__ticker_title}
                                onClick={() => props.edit(index, props.label)}
                            >
                                {item.name}
                            </div>
                            <div className={styles.__trash_icon} onClick={() => props.delete(index, props.label)}
                                style={{ cursor: props.editing ? '' : 'pointer'}}>
                                <FaRegTrashAlt size={17} style={{color: props.editing ? '#FFB3B3' : 'red'}} />
                            </div>
                        </>
                    }
                    {item.edit && <>
                        <div>
                            <input
                                data-tip={ props.isSameNameC ? 'changeName' : null}
                                data-for={ props.isSameNameC ? 'changeName' : null}
                                value={item.name.trimLeft()}
                                onChange={event => {
                                    props.editName(index, props.label, true, event.target.value)
                                }}
                                onKeyDown={(e) => props.clickEnter(e, index, props.label)}
                                className={styles.__input_name}
                                type="text"
                                style={{borderColor: props.isSameNameC ? 'red' : '', outlineColor: props.isSameNameC ? 'red' : ''}}
                            />
                            { props.isSameNameC &&
                                <Tooltip type="error" place="left" id={'changeName'} label={'This name already exist.'} show={true}/>
                            }
                        </div>
                        <div className={styles.__trash_icon}>
                            <X size={17} color={'red'}  style={{ cursor: 'pointer'}}
                                onClick={() => props.editName(index, props.label, false, item.name)}
                            />
                        </div>
                    </>
                    }
                </div>
                <Row style={{ paddingLeft: 9, paddingRight: 9 }}> <hr className={styles.__line} /></Row>
                </>
            )
        })
        return listTickers
    }
}

const Ticker = (props) => {

    let nameSpaces = props.inputName.charAt(props.inputName.length-1) === ' ';
    const list = renderList(props)
    let ticker = {
        name: props.inputName.trimLeft(),
        active: true,
        id: uuidv4()
    };
    return (
        <>
            <div className={styles.__border}
            >
                <Row center="xs">
                    <div className={styles.__subtitle} style={{ paddingBottom: 5 }}>
                        {props.title}
                    </div>
                </Row>
                <Row style={{ paddingLeft: 9, paddingRight: 9, marginBottom: 10 }}> <hr className={styles.__line} /></Row>
                <div className={styles.__container_input}>
                    { props.label !== 'weather' &&
                        <input
                            data-tip={ props.isSameName ? 'name' : nameSpaces ? 'spaces' : null}
                            data-for={ props.isSameName ? 'name' : nameSpaces ? 'spaces' : null}
                            className={styles.__input_plus}
                            style={{borderColor: props.isSameName || nameSpaces ? 'red' : '', outlineColor: props.isSameName ? 'red' : ''}}
                            value={ticker.name}
                            disabled={props.editing}
                            type="text"
                            placeholder="Add ticker"
                            onChange={event =>
                                props.changeInput(event.target.value, props.label)
                            }
                            onKeyDown={
                                (e) =>{
                                    if (!nameSpaces)
                                        props.clickEnterSave(e, ticker, props.label)
                                }
                            }
                        />
                    }
                    { props.isSameName &&
                        <Tooltip type="error" place="left" id={'name'} label={'This name already exists.'} show={true}/>
                    }
                    { nameSpaces &&
                        <Tooltip type="error" place="left" id={'spaces'} label={'Invalid name.'} show={true}/>
                    }
                    {   props.label === 'weather' &&
                        <div
                            data-tip={ props.isSameName ? 'inputWeather' : props.validCity ? null : 'invalidName'}
                            data-for={ props.isSameName ? 'inputWeather' :props.validCity ? null : 'invalidName' }
                            className={(props.isSameName || (!props.validCity && ticker.name !== '')) ? styles.__border_input : null}
                        >
                            <Autocomplete
                            placeholder = {"Add ticker"}
                            onChange = {
                                changedValue=>{
                                    props.changeInput(changedValue, props.label)
                            }}
                            maxOptionsLimit = {4}
                            getItemValue={(item)=>{ return item.city + ', ' + item.state }}
                            onSelect = {
                                selectedValue => {
                                    ticker.name = selectedValue
                                    props.onClickSaveWeather(ticker)
                            }}
                            itemsData={cities}
                            globalStyle = "
                                input {
                                    background: white;
                                    padding: 10px;
                                    font-size: 16px;
                                    border: #d9d9d9 1px solid;
                                    border-radius: 4px;
                                    font-family: Montserrat;
                                    font-style: normal;
                                    font-weight: 500;
                                    font-size: 14px;
                                    height: 40px;
                                    padding-left: 16px;
                                    outline: 0;
                                }

                                .autocomplete {
                                    width: 100%;
                                }

                                .___optionsDiv___ {
                                    border-bottom: 0.5 solid #d4d4d4;
                                    border-top: 1px solid #d4d4d4;
                                    text-align: left;
                                    top: 39px;
                                    font-family: Montserrat;
                                    font-size: 12px;
                                }

                                .___optionsDiv___ div {
                                    padding: 5px;
                                    border-bottom: 0 solid #d4d4d4;
                                }
                            "
                        />
                    </div>
                    }
                    { props.isSameName &&
                        <Tooltip type="error" place="left" id={'inputWeather'} label={'This name already exist.'} show={true}/>
                    }
                    { !props.validCity && ticker.name !== '' &&
                        <Tooltip type="error" place="left" id={'invalidName'} label={'Invalid City'} show={true}/>
                    }
                    <button
                        disabled={props.editing || ticker.name === '' || props.isSameName || nameSpaces || (!props.button && props.label === 'weather')}
                        className={styles.__container_icon}
                        onClick={() => {
                            props.onClickSave(ticker, props.label)
                        }}
                    >
                        <FaPlus size={17} style={{ position: 'relative', top: 2, right: 7, marginLeft: 12 }} />
                    </button>
                </div>
                <Row style={{ paddingLeft: 9, paddingRight: 9, marginTop: 10 }}> <hr className={styles.__line} /></Row>
                <div className={styles.__ticker_content}>
                    {props.title === 'Weather Forecast' && props.ticker.length > 0 &&
                        <div className={styles.__weather_defaul}>Default</div>
                    }
                    {list}
                </div>
            </div>
        </>
    )
}

export default Ticker

